import * as React from 'react';

/**
 * Sessão corrente: identidade (enfeite da topbar) e capabilities (decidem o
 * que fica bloqueado). Contexto em vez de prop porque o detalhe da versão é
 * aberto de três lugares (feed, homologação, página própria) e todos precisam
 * das mesmas capabilities. O provider é montado em `App`.
 */
export interface Sessao {
  usuario: { nome: string; detalhe: string } | null;
  /** Vazio enquanto `rolesCarregando` (e se o carregamento falhar): quem decide acesso usa `rolesCarregando` antes. */
  roles: string[];
  /**
   * As roles ainda não chegaram. Telas protegidas mostram skeleton nesse
   * intervalo — decidir "sem acesso" com roles vazias piscava o bloqueio para
   * quem tem a capability.
   */
  rolesCarregando: boolean;
}

export const SessaoContext = React.createContext<Sessao>({ usuario: null, roles: [], rolesCarregando: false });

export function useSessao(): Sessao {
  return React.useContext(SessaoContext);
}
